import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "action-item"
}

import { onUnmounted, ref, watch, CSSProperties, nextTick } from 'vue'
import { Action, DirectoryItem } from './types'
import ActionButton from './ActionButton.vue'

type Props = {
  actions: Action[]
  item?: DirectoryItem
  invert?: boolean
  tabIndex?: number
  stopClickPropagation?: boolean
}
type Emits = {
  (e: 'action', action: Action, item?: DirectoryItem): void
  (e: 'close'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ActionMenu',
  props: {
    actions: {},
    item: { default: undefined },
    invert: { type: Boolean, default: false },
    tabIndex: { default: 0 },
    stopClickPropagation: { type: Boolean, default: false }
  },
  emits: ["action", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const elementContainer = ref<HTMLElement | undefined>()
const actionMenuRef = ref<HTMLElement | undefined>()
const show = ref(false)
const menuStyle = ref<CSSProperties>({})

const emits = __emit

const handleOpenClick = (e: Event) => {
  show.value = !show.value
  if (props.stopClickPropagation) {
    e.stopPropagation()
  }
}

const handleActionClick = (action: Action) => {
  emits('action', action, props.item)
  show.value = false
}

const handleClickOutside = (event: MouseEvent) => {
  if (
    show.value &&
    elementContainer.value &&
    !elementContainer.value.contains(event.target as Node) &&
    actionMenuRef.value &&
    !actionMenuRef.value.contains(event.target as Node)
  ) {
    show.value = false
  }
}

watch(show, async (newValue) => {
  if (newValue) {
    await nextTick()

    if (elementContainer.value && actionMenuRef.value) {
      const triggerRect = elementContainer.value.getBoundingClientRect()
      const menuEl = actionMenuRef.value
      const menuHeight = menuEl.offsetHeight
      const menuWidth = menuEl.offsetWidth

      const viewportHeight = window.innerHeight
      const viewportWidth = window.innerWidth
      const viewportMargin = 8

      let finalTop: number
      let finalLeft: number

      finalTop = triggerRect.bottom + viewportMargin / 2

      if (finalTop + menuHeight > viewportHeight - viewportMargin) {
        const topIfAbove = triggerRect.top - menuHeight - viewportMargin / 2

        if (topIfAbove >= viewportMargin) {
          finalTop = topIfAbove
        } else {
          finalTop = viewportHeight - menuHeight - viewportMargin
          if (finalTop < viewportMargin) {
            finalTop = viewportMargin
          }
        }
      }
      finalTop = Math.max(
        viewportMargin,
        Math.min(finalTop, viewportHeight - menuHeight - viewportMargin)
      )

      finalLeft = triggerRect.left - menuWidth

      if (finalLeft < viewportMargin) {
        const alternativeLeft = triggerRect.left
        if (
          alternativeLeft + menuWidth <= viewportWidth - viewportMargin &&
          alternativeLeft >= viewportMargin
        ) {
          finalLeft = alternativeLeft
        } else {
          finalLeft = viewportMargin
        }
      } else if (finalLeft + menuWidth > viewportWidth - viewportMargin) {
        const alternativeLeftAlignRight = triggerRect.right - menuWidth
        if (
          alternativeLeftAlignRight >= viewportMargin &&
          alternativeLeftAlignRight + menuWidth <= viewportWidth - viewportMargin
        ) {
          finalLeft = alternativeLeftAlignRight
        } else {
          finalLeft = viewportWidth - menuWidth - viewportMargin
        }
      }

      finalLeft = Math.max(
        viewportMargin,
        Math.min(finalLeft, viewportWidth - menuWidth - viewportMargin)
      )
      if (menuWidth > viewportWidth - 2 * viewportMargin) {
        finalLeft = viewportMargin
      }

      menuStyle.value = {
        top: `${finalTop}px`,
        left: `${finalLeft}px`
      }
    }
    document.addEventListener('click', handleClickOutside, true)
  } else {
    document.removeEventListener('click', handleClickOutside, true)
    emits('close')
  }
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside, true)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "elementContainer",
    ref: elementContainer,
    class: "element-container"
  }, [
    _createElementVNode("div", {
      class: "button-wrapper",
      onClick: handleOpenClick,
      onKeydown: _cache[0] || (_cache[0] = _withKeys(
        (e) => {
          handleOpenClick(e)
          e.stopPropagation()
        }
      , ["enter"]))
    }, [
      _renderSlot(_ctx.$slots, "button")
    ], 32),
    (show.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "actionMenuRef",
          ref: actionMenuRef,
          class: "action-menu",
          style: _normalizeStyle(menuStyle.value),
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: action.actionName
            }, [
              (!_ctx.item || (_ctx.item && (action.appliesOn?.includes(_ctx.item.type) ?? true)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(ActionButton, {
                      action: action,
                      "show-text": "",
                      size: "fill",
                      "stop-click-propagation": "",
                      onAction: handleActionClick
                    }, null, 8, ["action"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 4))
      : _createCommentVNode("", true)
  ], 512))
}
}

})